module.exports = __webpack_public_path__ + "static/media/icon_more_protection.a32c5fad.svg";